"use client"

import type { BannerCarouselProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const BannerCarousel: ComponentConfig<BannerCarouselProps> = {
  label: "Tamda One | Banner Carousel",
  fields: {
    banners: {
      label: "Banners",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Banner ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
      },
      defaultItemProps: {
        image: "",
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    banners: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { BannerCarouselProps, BannerItem } from "@/types/types"
